export default __webpack_public_path__ + "static/media/coupen-dashboard.060010d3.svg";